module.exports = "<br>\n<br>\n<h5 class=\"title\">Discover an oasis of new products that leave you and this earth in a happy place</h5>\n<br>\n<br>\n<br>\n<br>\n<p>‘One is fruitful only at the cost of being rich in contradictions.’</p>\n<p>Friedrich Nietzsche</p>\n<img src=\"assets/img/homepage-img.jpg\">\n<img id=\"products\" src=\"assets/img/products.png\">\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/homepage/homepage.component.html
// module id = ../../../../../src/app/homepage/homepage.component.html
// module chunks = main